import type { MutableRefObject } from "react";
import type { Action } from "@core/features/actions";
import type { StepValidationState } from "@platform/features/onboarding";
import { QuizContainer } from "@platform/features/programQuiz";
import { OrgQuizStep } from "./OrgQuizStep";

export type Props = {
  programId: number;
  organizationId: number;
  /** The quiz action (has target_object_id pointing to the Quiz) */
  action: Action | undefined;
  onComplete: () => void;
  onSkip?: () => void;
  /** Whether to show action buttons in the quiz (default: true) */
  showActionButtons?: boolean;
  /** Callback when step validation state changes (for parent footer) */
  onStepStateChange?: (state: StepValidationState) => void;
  /** Ref to expose the submit handler to parent */
  submitRef?: MutableRefObject<(() => Promise<void> | void) | null>;
};

/**
 * Org onboarding quiz sub-step container.
 * Wraps the existing QuizContainer with the quiz ID from the action's target_object.
 */
export function OrgQuizStepContainer({
  action,
  onComplete,
  showActionButtons = true,
  onStepStateChange,
  submitRef,
}: Props) {
  const quizId =
    ((action?.target_object_data as Record<string, unknown>)?.quiz as
      | number
      | undefined) ?? action?.target_object_id;

  return (
    <OrgQuizStep hasQuiz={!!quizId}>
      {quizId && (
        <QuizContainer
          quizId={quizId}
          onCompleteQuiz={onComplete}
          showActionButtons={showActionButtons}
          onStepStateChange={onStepStateChange}
          submitRef={submitRef}
        />
      )}
    </OrgQuizStep>
  );
}

export default OrgQuizStepContainer;
